<template>
  <admin-profile :memberDetails="memberDetails" :edit="true" />
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */

import adminProfile from '@/views/Admin/Add/AdminAdd'
import GETSTORE from '@/store/memberProfileStore.js'

export default {
  name: 'AdminProfile',
  props: ['details'],
  mixins: [GETSTORE],
  components: {
    'admin-profile': adminProfile
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Admin/Profile/AdminProfile.vue